module.exports = __webpack_public_path__ + "static/media/bannertechnical.89ccddc7.jpg";